import { Handle, Position } from '@xyflow/react'
import { NavigationArrowIcon } from '@honestica/curecall-ui'
import { twMerge } from 'src/utils/tw-merge.util'

type TConnectingNodeButtonProps = {
  handleId?: string
  position?: Position
  isConnectable?: boolean
  isConnected?: boolean
  isPartOfSelectedEdge?: boolean
  showIcon?: boolean
  className?: string
}

export function ConnectingNodeButton({
  handleId,
  position = Position.Bottom,
  isConnectable = true,
  isConnected = false,
  isPartOfSelectedEdge = false,
  showIcon = true,
  className,
}: TConnectingNodeButtonProps) {
  const shouldShowIcon = !isConnected && showIcon && !isPartOfSelectedEdge

  const colorClassName = (() => {
    if (isPartOfSelectedEdge) return '!c-bg-primary-200 !c-border-2 !c-border-primary-500'
    if (shouldShowIcon) return '!c-bg-primary-600 !c-border-0'
    return '!c-bg-white !c-border !c-border-black'
  })()

  return (
    <Handle
      type="source"
      position={position}
      id={handleId}
      isConnectable={isConnectable}
      className={twMerge(
        '!c-relative !c-transform-none !c-inset-auto c-text-white c-flex c-items-center c-justify-center',
        colorClassName,
        className,
      )}
      style={{
        width: shouldShowIcon ? '28px' : '20px',
        height: shouldShowIcon ? '28px' : '20px',
      }}
    >
      {shouldShowIcon && <NavigationArrowIcon className="c-w-3.5" />}
    </Handle>
  )
}
